export default {"src":"/_next/static/media/mobile-application.89fd0343.svg","height":258,"width":258,"blurWidth":0,"blurHeight":0};